import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Users } from 'lucide-react';
import Logo from '../Branding/Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-[#0B1220] border-t border-slate-100 dark:border-slate-800 py-20 no-print">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 mb-20">
          <div className="max-w-md">
            <div className="flex items-center gap-3 mb-8">
              <Logo size={48} />
              <h3 className="text-3xl font-black text-slate-900 dark:text-white tracking-tighter">
                Invoice-Agent
              </h3>
            </div>
            <p className="text-lg text-slate-500 dark:text-slate-400 leading-relaxed mb-10 font-medium">
              A high-performance finance utility built for speed, aesthetics, and 100% data privacy.
              Engineered by <span className="text-brand-400 font-bold">CodAgenticAI</span> for the
              modern professional.
            </p>
            <div className="flex flex-wrap items-center gap-8 text-xs font-black text-slate-400 uppercase tracking-widest">
              <div className="flex items-center gap-2">
                <Users className="text-brand-400" size={20} /> Growing Community
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="text-emerald-500" size={20} /> Local-First Privacy
              </div>
            </div>
          </div>

          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-[3rem] p-12 border border-slate-100 dark:border-slate-800 shadow-sm">
            <h4 className="font-black text-2xl text-slate-900 dark:text-white mb-10 tracking-tight">
              Intelligence & Trust
            </h4>
            <div className="space-y-8">
              <div>
                <p className="font-bold text-lg text-slate-800 dark:text-slate-200">
                  Is my billing data secure?
                </p>
                <p className="text-slate-500 dark:text-slate-400 mt-3 leading-relaxed">
                  Absolutely. Every byte remains within your browser's local sandbox. We have no
                  backend databases to store or leak your sensitive project information.
                </p>
              </div>
              <div>
                <p className="font-bold text-lg text-slate-800 dark:text-slate-200">
                  Professional Grade Output
                </p>
                <p className="text-slate-500 dark:text-slate-400 mt-3 leading-relaxed">
                  Our style engine generates vector-quality documents that look perfect on any
                  screen or paper. No "built with" watermarks, ever.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-slate-100 dark:border-slate-800 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.5em] text-center md:text-left">
            © {new Date().getFullYear()} CodAgentic AI — All Rights Reserved
          </p>
          <div className="flex items-center gap-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">
            <Link to="/security" className="hover:text-brand-400 transition-colors cursor-pointer">
              Security
            </Link>
            <Link to="/privacy" className="hover:text-brand-400 transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-brand-400 transition-colors cursor-pointer">
              Terms & Conditions
            </Link>
            <Link to="/about" className="hover:text-brand-400 transition-colors cursor-pointer">
              About Us
            </Link>
            <Link to="/contact" className="hover:text-brand-400 transition-colors cursor-pointer">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
